const EMPTY_ICON_WIDTH = 512;
const EMPTY_ICON_HEIGHT = 512;

/* Define a empty icon that will be used before until the real icon data is fetched */
const emptyIcon = [EMPTY_ICON_WIDTH,
// width
EMPTY_ICON_HEIGHT,
// height
[''],
// ligatures
'',
// unicode
'' // svgPathData
];

export { EMPTY_ICON_HEIGHT as E, EMPTY_ICON_WIDTH as a, emptyIcon as e };
//# sourceMappingURL=emptyIcon-D6JwmRyF.js.map
